<template>
  <div class="keywords-container">
    <!-- 页面头部 -->
    <div class="keywords-header">
      <div>
        <h2>词条管理</h2>
      <div class="keywords-stats">
        分类数量: {{ allCategories.length }} (显示: {{ categories.length }})
      </div>
      </div>
      
      <!-- 搜索框 -->
      <div class="search-container">
        <el-input
          v-model="searchQuery"
          placeholder="请输入词条内容进行搜索..."
          class="search-input"
          @input="handleSearchInput"
          @focus="handleSearchFocus"
          @blur="handleSearchBlur"
          clearable
        >
          <template #prefix>
            <i class="el-icon-search"></i>
          </template>
        </el-input>
        
        <!-- 搜索结果下拉框 -->
        <div v-if="showDropdown && searchResults.length > 0" class="search-dropdown">
          <div
            v-for="keyword in searchResults"
            :key="keyword.book_keywords_id"
            class="search-item"
            @mousedown="selectKeyword(keyword)"
          >
            {{ keyword.keywords }}
          </div>
        </div>
        
        <!-- 无搜索结果提示 -->
        <div v-else-if="showDropdown && searchResults.length === 0 && searchQuery" class="search-dropdown">
          <div class="search-item no-results">
            暂无匹配的关键词
          </div>
        </div>
      </div>
      
      <div>
        <el-button v-if="hasMoreCategories" type="primary" @click="loadMoreCategories" :loading="loadingMoreCategories">
          加载更多
        </el-button>
      </div>
    </div>
    
    <!-- 词条柱体内容区域 -->
    <div class="keywords-content" v-if="!initialLoading && categories.length > 0">
      <!-- SVG连接线容器 -->
      <svg 
        class="connection-lines" 
        v-if="highlightKeywords.length > 1"
        :width="containerWidth" 
        :height="containerHeight"
      >
        <path 
          v-for="(line, index) in connectionLines" 
          :key="index"
          :d="line.path" 
          stroke="#FF8C42" 
          stroke-width="2" 
          fill="none" 
          opacity="0.8"
          stroke-dasharray="1,4"
          stroke-linecap="round"
          class="connection-line"
        >
          <animate 
            attributeName="stroke-dashoffset" 
            values="9;0" 
            dur="2s" 
            repeatCount="indefinite"
          />
        </path>
      </svg>
      
      <CategoryColumn
        v-for="(category, index) in categories"
        :key="category.classify_id"
        :category="category"
        :category-index="index"
        :keywords="keywordsByCategory[category.classify_id] || []"
        :keywords-count="keywordsCounts[category.classify_id] || 0"
        :has-more="hasMore[category.classify_id] || false"
        :loading="loading[category.classify_id] || false"
        :is-related="category.isRelated || false"
        :highlight-keywords="highlightKeywords"
        :active-popover-category-id="activePopoverCategoryId"
        @category-click="onCategoryClick"
        @keyword-click="onKeywordClick"
        @load-more="loadMoreKeywords"
      />
      
      <!-- 懒加载状态指示器 -->
      <div v-if="loadingMoreCategories" class="lazy-loading-indicator">
        <div class="loading-spinner"></div>
        <span>加载更多分类中...</span>
      </div>
      
      <!-- 加载完毕提示 -->
      <div v-else-if="!hasMoreCategories && categories.length > 0" class="load-complete-indicator">
        <span>已加载全部分类</span>
      </div>
    </div>
    
    
    <!-- 空状态 -->
    <div v-else-if="!initialLoading && categories.length === 0" class="empty-state">
      <p>暂无分类数据</p>
      <el-button type="primary" @click="refreshData">重新加载</el-button>
    </div>
    
    <!-- 加载状态 -->
    <div v-if="initialLoading" class="loading-container">
      <div class="loading-text">加载中...</div>
    </div>
  </div>
</template>

<script>
import CategoryColumn from './components/CategoryColumn.vue'
import keywordsLogic from './scripts/index.js'

export default {
  name: 'Keywords',
  components: {
    CategoryColumn
  },
  ...keywordsLogic
}
</script>

<style>
@import './styles/index.css';
</style>